import { iconNames } from "features/lightningLanders/constants";

export const customStyleManagerConfig = () => ({
  sectors: [
    {
      name: "Size",
      open: false,
      properties: [
        "width",
        {
          id: "flex-width",
          type: "integer",
          name: "FlexWidth",
          // units not working
          // units: ['px', '%'],
          property: "flex-basis",
          toRequire: true,
        },
        "height",
        "max-width",
        "min-height",
        "margin",
        "padding",
      ],
    },
    {
      name: "Layout",
      open: false,
      properties: [
        {
          name: "Display",
          property: "display",
          type: "select",
          defaults: "block",
          list: [
            { value: "block", name: "Block" },
            { value: "inline-block", name: "Inline Block" },
            { value: "flex", name: "Flex" },
            { value: "inline-flex", name: "Inline Flex" },
          ],
        },
        {
          name: "Flex Direction",
          property: "flex-direction",
          type: "radio",
          ui: "toggle",
          defaults: "row",
          requires: { display: ["flex", "inline-flex"] },
          list: [
            { value: "row", name: "Row", icon: iconNames.row, tooltip: "Items in a row (horizontal main axis)" },
            { value: "row-reverse", name: "Row Reverse", icon: iconNames.row_reverse, tooltip: "Items in a row, reversed order" },
            { value: "column", name: "Column", icon: iconNames.column, tooltip: "Items in a column (vertical main axis)" },
            { value: "column-reverse", name: "Column Reverse", icon: iconNames.column_reverse, tooltip: "Items in a column, reversed order" },
          ],
        },
        {
          name: "Justify Content",
          property: "justify-content",
          type: "radio",
          ui: "toggle",
          defaults: "flex-start",
          requires: { display: ["flex", "inline-flex"] },
          list: [
            { value: "flex-start", name: "Start", icon: iconNames.justify_start, tooltip: "Align items to the start of the main axis" },
            { value: "flex-end", name: "End", icon: iconNames.justify_end, tooltip: "Align items to the end of the main axis" },
            { value: "center", name: "Center", icon: iconNames.justify_center, tooltip: "Center items along the main axis" },
            { value: "space-between", name: "Space Between", icon: iconNames.justify_space_between, tooltip: "Equal space between items; none at the edges" },
            { value: "space-around", name: "Space Around", icon: iconNames.justify_space_around, tooltip: "Equal space around each item (half at edges)" },
            { value: "space-evenly", name: "Space Evenly", icon: iconNames.justify_space_evenly, tooltip: "Equal space between and around all items" },
          ],
        },
        {
          name: "Align Items",
          property: "align-items",
          type: "radio",
          ui: "toggle",
          defaults: "stretch",
          requires: { display: ["flex", "inline-flex"] },
          list: [
            { value: "flex-start", name: "Start", icon: iconNames.align_start, tooltip: "Align items to the start of the cross axis" },
            { value: "flex-end", name: "End", icon: iconNames.align_end, tooltip: "Align items to the end of the cross axis" },
            { value: "center", name: "Center", icon: iconNames.align_center, tooltip: "Center items along the cross axis" },
            { value: "baseline", name: "Baseline", icon: iconNames.align_baseline, tooltip: "Align items by their text baseline" },
            { value: "stretch", name: "Stretch", icon: iconNames.align_stretch, tooltip: "Stretch items to fill the cross axis" },
          ],
        },
        // not sure we need align content, I never use it
        // {
        //   name: "Align Content",
        //   property: "align-content",
        //   type: "radio",
        //   ui: "toggle",
        //   defaults: "stretch",
        //   requires: { display: ["flex", "inline-flex"] },
        //   list: [
        //     { value: "flex-start", name: "Start", icon: iconNames.align_content_start, tooltip: "Pack lines to the start of the cross axis (multi-line)" },
        //     { value: "flex-end", name: "End", icon: iconNames.align_content_end, tooltip: "Pack lines to the end of the cross axis (multi-line)" },
        //     { value: "center", name: "Center", icon: iconNames.align_content_center, tooltip: "Center lines along the cross axis (multi-line)" },
        //     { value: "space-between", name: "Space Between", icon: iconNames.align_content_space_between, tooltip: "Equal space between lines; none at edges (multi-line)" },
        //     { value: "space-around", name: "Space Around", icon: iconNames.align_content_space_around, tooltip: "Equal space around each line (multi-line)" },
        //     { value: "stretch", name: "Stretch", icon: iconNames.align_content_stretch, tooltip: "Stretch lines to fill the cross axis (multi-line)" },
        //   ],
        // },
        {
          name: "Flex Wrap",
          property: "flex-wrap",
          type: "radio",
          ui: "toggle",
          defaults: "nowrap",
          requires: { display: ["flex", "inline-flex"] },
          list: [
            { value: "nowrap", name: "No Wrap", icon: iconNames.wrap_nowrap, tooltip: "All items on a single line" },
            { value: "wrap", name: "Wrap", icon: iconNames.wrap_wrap, tooltip: "Items wrap onto multiple lines" },
            { value: "wrap-reverse", name: "Wrap Reverse", icon: iconNames.wrap_wrap_reverse, tooltip: "Items wrap, lines in reverse order" },
          ],
        },
        {
          name: "Gap",
          property: "gap",
          type: "integer",
          units: ["px", "%", "em", "rem"],
          defaults: "0",
          min: "0",
          requires: { display: ["flex", "inline-flex"] },
        },
        {
          name: "Float",
          property: "float",
          type: "radio",
          defaults: "none",
          requires: { display: ["block", "inline-block"] },
          list: [
            { value: "none", name: "None" },
            { value: "left", name: "Left" },
            { value: "right", name: "Right" },
          ],
        },
        {
          name: "Clear",
          property: "clear",
          type: "radio",
          defaults: "none",
          requires: { display: ["block", "inline-block"] },
          list: [
            { value: "none", name: "None" },
            { value: "left", name: "Left" },
            { value: "right", name: "Right" },
            { value: "both", name: "Both" },
          ],
        },
      ],
    },
    // Flex Item: only shown when selected component's parent has display flex (see LightningLandersStyles filter)
    {
      id: "flex-item",
      name: "Flex Item",
      open: false,
      properties: [
        {
          name: "Flex",
          property: "flex",
          type: "radio",
          defaults: "auto",
          ui: "toggle",
          list: [
            {
              value: "auto",
              name: "Auto",
              defaults: "auto",
              icon: iconNames.flex_auto,
            },
            {
              value: "1 1 100%",
              name: "Fill Container",
              defaults: "1 1 100%",
              icon: iconNames.flex_fill,
            },
            {
              value: "0 1 auto",
              name: "Hug Content",
              defaults: "0 1 auto",
              icon: iconNames.flex_hug,
            },
            { value: "", name: "Custom", icon: iconNames.flex_custom },
          ],
          onChange: (data) => {
            const { value, property } = data;
            const selected = property.target;
            if (selected && value !== "custom") {
              selected.addStyle({ flex: value });
            }
          },
        },
        {
          name: "Align Self",
          property: "align-self",
          type: "radio",
          defaults: "auto",
          list: [
            { value: "auto", name: "Auto" },
            { value: "flex-start", name: "Start" },
            { value: "flex-end", name: "End" },
            { value: "center", name: "Center" },
            { value: "baseline", name: "Baseline" },
            { value: "stretch", name: "Stretch" },
          ],
        },
      ],
    },
    {
      name: "Position",
      open: false,
      properties: [
        {
          name: "Position",
          property: "position",
          type: "select",
          defaults: "static",
          list: [
            { value: "static", name: "Static" },
            { value: "relative", name: "Relative" },
            { value: "absolute", name: "Absolute" },
            { value: "fixed", name: "Fixed" },
            { value: "sticky", name: "Sticky" },
          ],
        },
        {
          name: "Top",
          property: "top",
          type: "integer",
          units: ["px", "%", "em", "rem"],
          requires: { position: ["absolute", "relative", "fixed", "sticky"] },
        },
        {
          name: "Right",
          property: "right",
          type: "integer",
          units: ["px", "%", "em", "rem"],
          requires: { position: ["absolute", "relative", "fixed", "sticky"] },
        },
        {
          name: "Bottom",
          property: "bottom",
          type: "integer",
          units: ["px", "%", "em", "rem"],
          requires: { position: ["absolute", "relative", "fixed", "sticky"] },
        },
        {
          name: "Left",
          property: "left",
          type: "integer",
          units: ["px", "%", "em", "rem"],
          requires: { position: ["absolute", "relative", "fixed", "sticky"] },
        },
      ],
    },
    {
      name: "Typography",
      open: false,
      properties: [
        // "font-family",
        {
          extend: "font-family", // ← use the built-in font-family config
          defaults: "Arial, 'Helvetica', sans-serif", // ← your default only
        },
        "font-size",
        "font-weight",
        "letter-spacing",
        "color",
        "line-height",
        {
          extend: "text-align",
          // options not working
          // options: [
          //   { id : 'left',  label : 'Left',    className: 'fa fa-align-left'},
          //   { id : 'center',  label : 'Center',  className: 'fa fa-align-center' },
          //   { id : 'right',   label : 'Right',   className: 'fa fa-align-right'},
          //   { id : 'justify', label : 'Justify',   className: 'fa fa-align-justify'}
          // ],
        },
        {
          property: "text-decoration",
          type: "radio",
          default: "none",
          // options not working
          // options: [
          //   { id: 'none', label: 'None', className: 'fa fa-times'},
          //   { id: 'underline', label: 'underline', className: 'fa fa-underline' },
          //   { id: 'line-through', label: 'Line-through', className: 'fa fa-strikethrough'}
          // ],
        },
        "text-shadow",
      ],
    },
    {
      name: "Decorations",
      open: false,
      properties: [
        {
          name: "Background Color",
          property: "background-color",
          type: "color",
        },
        {
          name: "Background Image",
          property: "background-image",
          type: "file",
          functionName: "url",
          full: true,
        },
        {
          name: "Background Size",
          property: "background-size",
          type: "select",
          // defaults: "cover",
          full: true,
          list: [
            { value: "cover", name: "Cover" },
            { value: "contain", name: "Contain" },
            { value: "auto", name: "Auto" },
            { value: "100% 100%", name: "Stretch" },
          ],
        },
        {
          name: "Background Position",
          property: "background-position",
          type: "select",
          // defaults: "center center",
          full: true,
          list: [
            { value: "center center", name: "Center" },
            { value: "top left", name: "Top Left" },
            { value: "top center", name: "Top Center" },
            { value: "top right", name: "Top Right" },
            { value: "center left", name: "Center Left" },
            { value: "center right", name: "Center Right" },
            { value: "bottom left", name: "Bottom Left" },
            { value: "bottom center", name: "Bottom Center" },
            { value: "bottom right", name: "Bottom Right" },
          ],
        },
        {
          name: "Background Repeat",
          property: "background-repeat",
          type: "select",
          // defaults: "no-repeat",
          full: true,
          list: [
            { value: "no-repeat", name: "No Repeat" },
            { value: "repeat", name: "Repeat" },
            { value: "repeat-x", name: "Repeat X" },
            { value: "repeat-y", name: "Repeat Y" },
          ],
        },
        "opacity",
        "border-radius",
        "border",
        "box-shadow",
      ],
    },
    {
      name: "Extra",
      open: false,
      buildProps: ["transition", "perspective", "transform"],
    },
  ],
});
